import logo from './logo.svg';
import './App.css';
import UrlShortener from './Shorty/UrlShortener';

function App() {
  return (
    <div className="App">
      <UrlShortener />
    </div>
  );
}

export default App;
